import React from "react";
import styles from "../utils/gridStyles.js";
import dateFormat from 'dateformat';
import setHeaderRender from "../../components/app/setHeaderRender";
import { CiGlobe } from "react-icons/ci";

const setColumns = ({ modalDetail, allowWrite, changeDelay, updateSelectMultiRows, selectUnselectAllRows}) => {

    return [
        {
            id: "checkbox",
            visible: true,
            pinned: true,
            width: "54px",
            cellRenderer: ({ value, data, onChange, disabled}) => ( <input type="checkbox" onChange={ onChange } checked={ value } disabled={ disabled }
            onClick={ () => { updateSelectMultiRows(data.code); } } /> ),
            headerCellRenderer: ({ checked, disabled, onChange }) => ( <input type="checkbox" onChange={ onChange } checked={ checked } disabled={ disabled } 
            onClick={selectUnselectAllRows} /> )
        },
        {
            id: "code",
            field: "code",
            label: "code",
            width: '100px',
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'code', changeDelay, tableManager, column}) )
        },
        {
            id: "2",
            field: "name",
            label: "Names",
            sortable: false,
            resizable: true,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Name', changeDelay, tableManager, column}) )
        },
        {
            id: "3",
            field: "username",
            label: "Username",
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'UserName', changeDelay, tableManager, column}) )
        },
        {
            id: "path",
            field: "path",
            label: "Path",
            width: '250px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Path (Domain)', changeDelay, tableManager, column}) )
        },
        {
            id: "4",
            field: "providerType",
            label: "ProviderType",
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'ProviderType', changeDelay, tableManager, column}) )
        },
        {
            id: "9",
            field: "priorityLevel",
            label: "PriorityLevel",
            width: '150px',
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'PriorityLevel', changeDelay, tableManager, column}) ),
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => ( (data.priorityLevel) ? data.priorityLevel : '0') 
        },
        {
            id: "5",
            label: 'Shop Id',
            field: "t1data.shopId",
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Shop Id', changeDelay, tableManager, column}) ),
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => ( data.t1data.shopId )
        },
        {
            id: "6",
            label: 'Plan Name',
            field: "suscription_id.name",
            sortable: false,
            headerCellRenderer: ({tableManager, column }) => ( setHeaderRender({'nameHeader':'Plan Name', changeDelay, tableManager, column}) ),
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (data.suscription_id.name)
        },
        {
            id: "7",
            label: 'Expires On',
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.suscription_id.expiresOn, "dd/mm/yyyy", true))
        },
        {
            id: "8",
            field: "createdAt",
            label: "CreatedAt",
            sortable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (dateFormat(data.createdAt, "dd/mm/yyyy", true)),
            sort: ({ a, b, isAscending }) => {
                let aa = a.split("/").reverse().join(),
                    bb = b.split("/").reverse().join();
                return aa < bb
                    ? isAscending
                        ? -1
                        : 1
                    : aa > bb
                        ? isAscending
                            ? 1
                            : -1
                        : 0;
            }
        },
        {
            id: "buttons",
            label: "Action",
            width: '110px',
            pinned: true,
            sortable: false,
            resizable: false,
            cellRenderer: ({
                tableManager,
                value,
                data,
                column,
                colIndex,
                rowIndex
            }) => (
                <div style={styles.styleButton.buttonsCellContainer}>
                    
                    {allowWrite
                        ? (<> <button
                            title="Edit"
                            style={styles.styleButton.editButton}
                            onClick={(e) => {
                                e.stopPropagation();
                                modalDetail(data.code, "Edit");
                            }}
                        >
                            {styles.EDIT_SVG}
                        </button> {" - "} </>)
                        : ''
                    }
                    <button
                        title="View"
                        style={styles.styleButton.viewButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            modalDetail(data.code, "View");
                        }}
                    >
                        {styles.VIEW_SVG}
                    </button>
                    <button
                        title="Open Path"
                        style={styles.styleButton.editButton}
                        onClick={(e) => {
                            e.stopPropagation();
                            window.open('https://'+data.path, '_blank', 'noreferrer');
                        }}
                    >
                        <CiGlobe color="blue"/>
                    </button>
                </div>
            )
        }
    ];
};

export default setColumns;
